import MenuItems from "@/menu";
import {mapState} from 'vuex';

export default {
    data() {
        return {
            hasAccess: false
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            let items = [];
            MenuItems.forEach(item => {
                items.push({
                    label: item.label,
                    trans: item.trans,
                    route: item.route
                });

                item.subItems.forEach(child => {
                    if (child) {
                        items.push({
                            label: child.label,
                            trans: child.trans,
                            route: child.route
                        });
                    }
                });
            });

            let menuItem = items.find(i => i.route === to.path);

            if (menuItem) {
                vm.$api()
                    .post('/apps/check', {
                        app: menuItem.label
                    })
                    .then(({data}) => {
                        if (data.access) {
                            vm.hasAccess = true;

                            return true;
                        } else {
                            vm.$noty.error('You do not have access to ' + vm.trans(menuItem.trans));
                            vm.$router.replace('/');

                            return false;
                        }
                    });
            } else {
                vm.$api().get('verify').then(() => vm.hasAccess = true);
            }

            return false;
        });
    },
}
